module.exports = __webpack_public_path__ + "img/Rectangle 8.e384328b.svg";